define('modules/judges/sidebyside/js/base.js',["app/config", "app/util", "jquery", "templates", "skrollr", "waypoints"], function (config, util, $, templates, skrollr) {
    return {
        name: 'judges',
        selectors: '.judgePageWrap, #judgeSample, .judgeSection, .judgeSample',
        remoteData: [config.urls.judges],
        routes: [{
            route: 'judges/(.*)',
            fn: function (hash) {
                $('#judges .judgebox[data-judge="' + hash.split('/')[1] + '"]').trigger('click');
            },
            extra: true,
            delay: 2500
        }, {
            route: 'judges',
            fn: 'showLeftSide',
            extra: true,
            delay: 500
        }, {
            route: 'judges/peer-to-peer',
            fn: 'gotojudgesgrouptwo',
            extra: true,
            delay: 500
        }, {
            route: 'judges/evaluation-panel',
            fn: 'gotojudgesgroupone',
            extra: true,
            delay: 500
        }],

        leftWaypoints: [],

        config: {
            rightPanelLayout: true,
            showTypeBar: false
        },


        initialize: function (data) {

            // Figure out the grouping for judges and render the page template
            this.renderTemplates(data);

            // top buttons scroll to section
            $('.introBtnContainer .btn').click(function (e) {
                e.preventDefault();
                var el = $(this),
                    group = $(el).attr('data-judgegroup');
                $($('.judgeGroup[data-judgegroup="' + group + '"]').scrollParent()).animate({
                    scrollTop: $('.judgeGroup[data-judgegroup="' + group + '"]').offset().top
                }, 500);
                Waypoint.refreshAll();
            });

            // TODO Set this up as config option with selector
            // cloning this container because we need it in the intro section
            //var btnContainerClone = $('.introBtnContainer').clone(true);
            //$('.introBtnContainer').remove();
            //$('.judgesPageContainer .btn-clone-container').html(btnContainerClone);

            // Add the click handlers to judgeboxes
            $('.judgePageWrap .judgebox').on('click', $.proxy(this.onJudgeBoxClick, this));

            // Init Skrollr
            this.initSkrollr();
            var lastScrollTop = 0;
            // Bottom toggle bar navigation, this mostly chains to other methods
            $('.judgeTypeBar span, .typeIcon').click($.proxy(function (e) {
                e.preventDefault();

                var el = $(e.delegateTarget),
                    group = $(el).attr('data-judgegroup');

                $($('.judgeGroup[data-judgegroup="' + group + '"]').scrollParent()).animate({
                    scrollTop: $('.judgeGroup[data-judgegroup="' + group + '"]').offset().top
                }, 500);
                Waypoint.refreshAll();

                /*//var st = $('.judgeGroup[data-judgegroup="'+group+'"]').scrollTop();
                var st = $('.judgeGroup[data-judgegroup="'+group+'"]').offset().top;
                //var lastScrollTop = 0;
                if($(el).hasClass('backToggle')) {
                    this.showLeftSide(group);
                } else if($('#judgesDetail:visible').length > 0) {
                    this.showRightSide(group);
                } else {

                    // We are still on the left side and scrolling within
                    if (st > lastScrollTop){
                    	// if we're scrolling down less top padding
						util.scrollElToTop($('.judgeGroup[data-judgegroup="'+group+'"]'),-40);
					} else {
						// if we're scrolling up more top padding
						util.scrollElToTop($('.judgeGroup[data-judgegroup="'+group+'"]'),-220);
					}
					lastScrollTop = st;

                    //util.scrollElToTop($('.judgeGroup[data-judgegroup="'+group+'"]'),-40);
                    Waypoint.refreshAll();
                }*/
            }, this));

            // Waypoint for toggling the active tab for judges group
            $('.judgePageWrap .judgeGroup').each($.proxy(function (index, el) {
                var waypoint = new Waypoint({
                    offset: 200,
                    element: $(el),
                    handler: $.proxy(function () {
                        $('.judgeTypeBar span').toggleClass('enabled', false);
                        $('.judgeTypeBar span[data-judgegroup="' + $(el).attr('data-judgegroup') + '"]').toggleClass('enabled', true);
                    }, this)
                });
                this.leftWaypoints.push(waypoint);
                // Secondary waypoint with 1px offset, due to scrollTo handling in the up direction with an exact offset (see https://github.com/imakewebthings/waypoints/issues/346#issuecomment-65501126)
                // TODO - P2 Make a Waypoint adapter with this in it and other common use cases
                var waypoint = new Waypoint({
                    offset: 199,
                    element: $(el),
                    handler: $.proxy(function (direction) {
                        if (direction == 'up') {
                            $('.judgeTypeBar span').toggleClass('enabled', false);
                            $('.judgeTypeBar span[data-judgegroup="' + $(el).attr('data-judgegroup') + '"]').toggleClass('enabled', true);
                        }
                    }, this)
                });
                this.leftWaypoints.push(waypoint);
            }, this));


            // Apply hashchange for direct judge routing
            /* $(window).hashchange($.proxy(function(){
                 if(location.hash.split('/')[0].substr(1) == 'judges') {
                     skrollr.get().refresh();
                     if(location.hash.split('/')[1]) {
                         // Get existing hash and use it to trigger the click
                         $('#judges .judgebox[data-judge="'+location.hash.split('/')[1]+'"]').trigger('click');
                     } else {
                         this.showLeftSide();
                     }
                 }
             },this));*/
            this.mobileToggleBar();
            this.refreshAnim();

            this.loadJudgeSample(data);
        },

        gotojudgesgroupone: function () {
            $('.navbarWrap').removeClass('.slideDownIn').addClass('slideUpOut');
            $('html, body').animate({
                scrollTop: $('.load_judges_g1_h3').offset().top - 100
            }, 500);
        },
        gotojudgesgrouptwo: function () {
            $('.navbarWrap').removeClass('.slideDownIn').addClass('slideUpOut');
            $('html, body').animate({
                scrollTop: $('.load_judges_g2_h3').offset().top - 100
            }, 500);
        },
        // Groups and renders the template data
        renderTemplates: function (data) {
            var judgeGroups = [],
                templateData = {
                    judgeGroups: []
                };
            $.each(data, function (index, record) {
                if (!judgeGroups[record.type]) {
                    judgeGroups[record.type] = {
                        name: record.type,
                        desc: record.desc,
                        title: record.shortDescription,
                        cms: record.cms,
                        records: []
                    };
                }
                judgeGroups[record.type].records.push(record);
            });
            for (var key in judgeGroups) {
                templateData.judgeGroups.push(judgeGroups[key]);
            }
            this.templateData = templateData;
            $('.judgePageWrap').append(templates.judgespage({
                data: templateData,
                config: this.config
            }));
        },

        // Handle for when a judge is clicked on, this can also be manually triggered
        onJudgeBoxClick: function (e) {

            e.preventDefault();
            $.each(this.leftWaypoints, function () {
                this.disable();
            });

            var jGroup = $(e.delegateTarget).attr('data-judgegroup'),
                jId = $(e.delegateTarget).attr('data-judge');

            if (this.config.rightPanelLayout) {
                this.showRightSide(jGroup);

                $('#judgesDetail').find('.tplWrapper').css('overflow', 'scroll');
                util.scrollElToTop($('#judgesDetail').find('*[data-pagenav][data-id="' + jId + '"]'), 0, 1);
                setTimeout($.proxy(function () {
                    $('body').trigger('pagenavupdate');
                    $('#judgesDetail').find('.tplWrapper').css('overflow', 'hidden');
                }, this), 5);

            } else {
                $('#judgesDetail').show();
            }

            setTimeout($.proxy(function () {
                $('body').addClass('judgeDetailOpen');
                $('.navbarWrap').addClass('hidden');
                if (skrollr.get()) {
                    skrollr.get().refresh(); // Refresh skrollr for new height layout changes
                }
                setTimeout(function () {
                    //$('.navbarWrap').removeClass('slideDownIn').addClass('slideUpOut');
                }, 60); // TODO - We need to address this in a better way to handle the temporary flash, attempt to reduce timeout
            }, this), 50);

            // Update the text on the judges bar
            this.resetToggleBar(jGroup, true);
            this.mobileToggleBar();

            $('#judgesDetail .judgeInfoGroup').toggle(false);
            $('#judgesDetail .judgeInfoGroup[data-judgegroup="' + jGroup + '"]').toggle(true);

            if (!this.config.rightPanelLayout) {
                if ($(window).width() >= 768) {
                    if ($('.judgePageWrap .judgeinfoWrap[data-judge="' + jId + '"]').offset().top < 200) {
                        util.scrollElToTop($('.judgePageWrap .judgeinfoWrap[data-judge="' + jId + '"]'), -220);
                    } else {
                        util.scrollElToTop($('.judgePageWrap .judgeinfoWrap[data-judge="' + jId + '"]'), -40);
                    }
                } else {
                    util.scrollElToTop($('.judgePageWrap .judgeinfoWrap[data-judge="' + jId + '"]'), -20);
                }
                $('body').trigger('pagenavupdate');
            }

            return false;

        },

        initSkrollr: function () {
            // Init skrollr, only one instance will exist so this can and should be called from all files requiring it
            skrollr.init({
                smoothScrollingDuration: 50,
                forceHeight: false,
                mobileCheck: function () {
                    return false;
                }, // Uncomment mobileCheck for mobile debugging
                constants: {
                    // Viewport height - dynamic constant
                    vph: function () {
                        return $('html').height() || $('#form1').height();
                    },
                    mid: function () {
                        return $('html').height() / 2 || $('#form1').height() / 2;
                    },
                    35: function () {
                        return Math.round($('html').height() * 0.35) || Math.round($('#form1').height() * 0.35);
                    }
                }
            });
        },

        resetToggleBar: function (active, rightside) {

            if (rightside && this.config.rightPanelLayout) {
                $('.judgePageWrap .judgeTypeBar').hide();
            } else {
                $('.judgePageWrap .judgeTypeBar').show();
            }

            $('.nav .typeIcon').each(function () {
                $(this).text($(this).attr('data-judgegroup'));
            });

            $('.judgePageWrap .judgeTypeBar span').removeClass('backToggle enabled view');
            $('.judgePageWrap .judgeTypeBar span').each(function () {
                $(this).text($(this).attr('data-judgegroup'));
                if (active && active == $(this).attr('data-judgegroup') && !rightside) {
                    $(this).addClass('enabled');
                }
                if (active && active == $(this).attr('data-judgegroup') && rightside) {
                    $(this).addClass('backToggle');
                } else if (rightside) {
                    $(this).addClass('view');
                }
            });
        },

        // Moving back to the left side
        showLeftSide: function (judgegroup) {


            // Reset elements
            $('body').removeClass('judgeDetailOpen locked');
            $('.navbarWrap').removeClass('slideUpOut').addClass('slideDownIn');

            // without changing the css to get rid of the borderbox from judgegroup
            // on judge detail view
            $('#judges .judgeGroup').css('left', '0px'); // TODO - Move to CSS


            this.resetToggleBar(judgegroup);
            this.mobileToggleBar();

            $.each(this.leftWaypoints, function () {
                this.enable();
            });

            var scrollBackToEl = $('.judgePageWrap .judgeGroup[data-judgegroup="' + (judgegroup || '') + '"]');
            setTimeout($.proxy(function () {
                if (this.config.rightPanelLayout) {
                    this.refreshAnim();
                } else {
                    $('#judgesDetail').hide();
                    this.refreshAnim();
                    if ($(window).width() >= 768) {
                        util.scrollElToTop((scrollBackToEl.length > 0 ? scrollBackToEl : false), -40);
                    } else {
                        util.scrollElToTop((scrollBackToEl.length > 0 ? scrollBackToEl : false), -100);
                    }
                }
            }, this), 50);

            if (this.config.rightPanelLayout) {
                setTimeout($.proxy(function () {
                    $('#judgesDetail').empty().hide();
                }, this), 1000);
            }

        },

        // Staying on the right side and swapping content
        showRightSide: function (group) {


            $.each(this.leftWaypoints, function () {
                this.disable();
            });

            this.resetToggleBar(group, true);
            this.mobileToggleBar();

            if (this.config.rightPanelLayout) {
                var groupData = null;
                $.each(this.templateData['judgeGroups'], function (i, d) {
                    if (d.name == group) {
                        groupData = d.records;
                    }
                });
                $('#judgesDetail').html(templates.sharedcard({
                    records: $.map(groupData, function (rec) {
                        return {
                            id: rec.id,
                            h3: rec.name,
                            h4: rec.shortDescription,
                            span: rec.date,
                            type: rec.type,
                            image: rec.image,
                            content: rec.longDescription
                        }
                    })
                }));

                $('body').addClass('locked').trigger('pagenavupdate');
                $('#judgesDetail').show();
                $('#judgesDetail').find('.icon-close').on('click', $.proxy(function (e) {
                    e.preventDefault();
                    $('#judgesDetail').find('.tplWrapper').removeClass('open');
                    $('.navbarWrap').removeClass('hidden');
                    this.showLeftSide(group);
                }, this));
                setTimeout(function () {
                    $('#judgesDetail').find('.tplWrapper').addClass('open');
                }, 25);

            } else {
                // Hide the other sections, and show the new active section
                $('#judgesDetail .judgeInfoGroup').hide();
                $('#judgesDetail .judgeInfoGroup[data-judgegroup="' + group + '"]').show();

                // Scroll to and refresh
                $('html,body').animate({
                    scrollTop: -40
                }, 500, 'swing');

                //$('#judgesDetail .nav .currentCount').text(1);
                this.refreshAnim();
                setTimeout(function () {
                    $('body').trigger('pagenavupdate');
                }, 600);

            }

            $('.navbarWrap').removeClass('slideDownIn').addClass('slideUpOut');

        },

        mobileToggleBar: function () {
            $('.judgePageWrap .judgeTypeBar span').each(function () {
                var w = $(window).width();
                if (w < 768) {
                    //$('.judgeTypeBar span').each(function(){
                    var text = $(this).text();
                    var words = $(this).text().split(' ');
                    var html = '';
                    $.each(words, function () {
                        html += this.substring(0, 1);
                    });
                    $(this).html(html);
                    //});
                }
            });


            $('.nav .typeIcon').each(function () {
                var w = $(window).width();
                if (w < 768) {
                    //$('.judgeTypeBar span').each(function(){
                    var text = $(this).text();
                    var words = $(this).text().split(' ');
                    var html = '';
                    $.each(words, function () {
                        html += this.substring(0, 1);
                    });
                    $(this).html(html);
                    //});
                }
            });
        },

        // Refresh animation states
        refreshAnim: function () {
            Waypoint.refreshAll();
            if (skrollr.get()) {
                skrollr.get().refresh();
            }
        },

        loadJudgeSample: function (data) {
            if ($('.judgeSample').length == 0) {
                return;
            }
            // $('.judgeSample').html(templates.judgesample(util.getRandomRecords(data, 8)));
            $('.judgeSample').html(templates.judgesample(data));
            $('.judgeSample .item').first().addClass('active');

            $('.judgeSample').find('.carousel').carousel({
              interval: 8000
            });
            
            util.bootstrapNumberCarousel('.judge-sample-carousel');


            $('.judgeSample .judgebox').on('click', $.proxy(function (e) {
                e.preventDefault();
                window.location.hash = 'judges/' + $(e.currentTarget).attr('data-judge');
            }, this));
        }
    }
});

